import React from 'react'
import { Field } from 'react-final-form'
import styled from 'styled-components'

import { useListRequest, useRequest } from '../hooks/request'
import { notificationList, notificationBroadcastPath, notificationBroadcast } from '../requests/notification'
import { getFullName } from '../utils/getFullName'
import { dateToDateTime } from '../utils/dateToDDMMYYYY'
import { NOTIFICATION_SUBTYPE_OPTIONS } from '../constants/notificationSubtype'
import { VARIANT_SUCCESS } from '../constants/variants'

import { PageTitle } from './common/PageTitle'
import { PageContent } from './layout/layout'
import { List } from './common/List'
import { Menu } from './common/Typography'
import { Form } from './common/Form'
import { InputField } from './fields/InputField'
import { SelectField } from './fields/SelectField'
import { Margin } from './common/Margin'
import { Button } from './common/Button'

const titles = [
  { title: 'type' },
  { title: 'author' },
  { title: 'message', size: 3 },
  { title: 'publicationDate' },
]

const displayItem = (item) => [
  { content: <Menu bold tradId={`notificationSubType.${item.content.subType}`} /> },
  getFullName({ user: item.content.who }),
  item.content.text,
  dateToDateTime(item.date),
]

export const NotificationList = () => {
  const notificationListRequest = useListRequest({
    startSort: '-date',
    start: true,
    request: notificationList,
  })

  const notificationBroadcastRequest = useRequest({
    request: notificationBroadcast,
    handler: (p) => p.then(() => {
      notificationListRequest.fetch()
    }),
  })

  return (
    <>
      <PageTitle tradId="notificationPublish" />
      <PageContent>
        <Form path={notificationBroadcastPath} onSubmit={notificationBroadcastRequest.fetch}>
          {({ handleSubmit, form }) => (
            <>
              <FormWrapper>
                <Field
                  component={CustomSelectField}
                  label="notificationSubType"
                  required
                  options={NOTIFICATION_SUBTYPE_OPTIONS}
                  name="subType"
                  translate
                  placeholder="notificationSubTypePlaceholder"
                />
                <Margin h={15} />
                <Field
                  component={CustomInputField}
                  maxLength={140}
                  placeholder="notificationTextPlaceholder"
                  label="typeMessage"
                  required
                  name="text"
                />
              </FormWrapper>
              <ButtonWrapper>
                <Button
                  onClick={async (...rest) => {
                    const ret = await handleSubmit(...rest)
                    const { values } = form.getState()
                    if (!form.getState().hasValidationErrors) {
                      Object.keys(values).forEach((key) => {
                        form.resetFieldState(key)
                      })
                      form.reset()
                    }

                    return ret
                  }}
                  tradId="publishSubmit"
                  filled
                  variant={VARIANT_SUCCESS}
                  bold
                />
              </ButtonWrapper>
            </>
          )}
        </Form>
        <List
          listRequest={notificationListRequest}
          columnTitles={titles}
          displayItem={displayItem}
        />
      </PageContent>
    </>
  )
}

const FormWrapper = styled.div`
  display: flex;
  width: 100%;

`

const CustomSelectField = styled(SelectField)`
  min-width: 249px;
`

const CustomInputField = styled(InputField)`
  flex: 1;
`
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`
